export default "__VITE_ASSET__1a1090fb__"